module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/279.5a82d341.png";